<template>
  <div class="ven-rec-producao">
    <!-- SETA O STATUS DA TELA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA OS DADOS DA PAGINA -->
    <template v-else>
      <!-- TITULO DO DOCUMENTO -->
      <div class="conteudo">
        <table>
          <tbody>
            <tr>
              <td class="texto_tam12" style="text-align: center;">
                <span v-html="licenca.rSocial"></span>
                <span v-html="' - ' + venReciboProducaoFormatarVencimento(venda.vencimento_ptbr)"></span>
                <span v-html="' - Venda ' + venReciboProducaoFormatarNumeroVenda(venda.cod_venda)"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- DADOS DO EMITENTE -->
      <div class="conteudo">
        <table>
          <tbody>
            <tr>
              <td class="texto_tam10">Telefones:</td>
              <td class="texto_tam10" v-html="licenca.telefone"></td>
              <td class="texto_tam10" rowspan="7" style="width: 170px; padding: 0px 5px; text-align: center;">
                <!-- <img :src="$store.state.logotipo" ref="logo" @load="venReciboProducaoCalcularTamanhoLogo()"> -->
                <img :src="licenca.logotipo" ref="logo" @load="venReciboProducaoCalcularTamanhoLogo()">
              </td>
            </tr>
            <!-- <tr>
              <td class="texto_tam10">CNPJ:</td>
              <td class="texto_tam10" v-html="licenca.cnpj"></td>
              <td class="texto_tam10" rowspan="7" style="width: 170px; padding: 0px 5px; text-align: center;">
                <img :src="$store.state.logotipo" ref="logo" @load="venReciboProducaoCalcularTamanhoLogo()">
              </td>
            </tr>
            <tr>
              <td class="texto_tam10">I.E.:</td>
              <td class="texto_tam10" v-html="licenca.ie"></td>
            </tr>
            <tr>
              <td class="texto_tam10">Telefones:</td>
              <td class="texto_tam10" v-html="licenca.telefone"></td>
            </tr>
            <tr>
              <td class="texto_tam10">Endereço:</td>
              <td class="texto_tam10">
                <span v-html="licenca.endereco"></span>, <span v-html="licenca.numero"></span>
                <span v-if="[ '', null, undefined ].indexOf(licenca.complemento) === -1" v-html="' (' + licenca.complemento + ')'"></span>
                <span v-html="' - ' + licenca.bairro"></span>
                <span v-html="' - ' + licenca.cidade"></span>
                <span v-html="' (' + licenca.uf + ')'"></span>
              </td>
            </tr>
            <tr>
              <td class="texto_tam10">CEP:</td>
              <td class="texto_tam10">
                <span v-html="venReciboProducaoFormatarCep(licenca.cep)"></span>
              </td>
            </tr>
            <tr>
              <td class="texto_tam10">Site:</td>
              <td class="texto_tam10" v-html="licenca.site"></td>
            </tr>
            <tr>
              <td class="texto_tam10">E-mail:</td>
              <td class="texto_tam10">
                <a :href="'mailto:' + licenca.email" target="_blank" class="texto_tam10" v-html="licenca.email"></a>
              </td>
            </tr> -->
            <!-- <tr>
              <td class="texto_tam10">Vendedor(a):</td>
              <td class="texto_tam10">Luis Rafael Beiger Kucek</td>
            </tr> -->
          </tbody>
        </table>
      </div>

      <!-- DADOS DO CLIENTE -->
      <div class="conteudo">
        <table>
          <tbody>
            <tr>
              <td class="texto_tam10">Cliente:</td>
              <td class="texto_tam10" v-html="venda.id_con_nome"></td>
            </tr>
            <!-- <tr v-if="venda.id_con_pessoa === 'j'">
              <td class="texto_tam10">Empresa:</td>
              <td class="texto_tam10" v-html="venda.id_con_empresa"></td>
            </tr>
            <tr>
              <td class="texto_tam10">CNPJ:</td>
              <td class="texto_tam10" v-html="venda.id_con_cnpj_cpf"></td>
            </tr>
            <tr>
              <td class="texto_tam10">I.E.:</td>
              <td class="texto_tam10" v-html="venda.id_con_ie"></td>
            </tr>
            <tr>
              <td class="texto_tam10">Telefones:</td>
              <td class="texto_tam10">
                <template v-if="[ '', null, undefined ].indexOf(venda.id_con_tel_res) === -1">
                  Res: {{ venda.id_con_tel_res }}
                  ::
                </template>
                <template v-if="[ '', null, undefined ].indexOf(venda.id_con_tel_cel) === -1">
                  Cel: {{ venda.id_con_tel_cel }}
                  ::
                </template>
                <template v-if="[ '', null, undefined ].indexOf(venda.id_con_tel_com) === -1">
                  Com: {{ venda.id_con_tel_com }}
                </template>
              </td>
            </tr>
            <tr>
              <td class="texto_tam10">Endereço:</td>
              <td class="texto_tam10">
                <span v-html="venda.id_con_end"></span>, <span v-html="venda.id_con_num"></span>
                <span v-if="[ '', null, undefined ].indexOf(venda.id_con_comp) === -1" v-html="' (' + venda.id_con_comp + ')'"></span>
                <span v-html="' - CEP ' + venReciboProducaoFormatarCep(venda.id_con_cep)"></span>
                <span v-html="' - ' + venda.id_con_bairro"></span>
                <span v-html="' - ' + venda.id_con_id_cidade_cidade"></span>
                <span v-html="' (' + venda.id_con_id_estado + ')'"></span>
              </td>
            </tr>
            <tr v-if="[ '', null, undefined ].indexOf(venda.id_con_id_site) === -1">
              <td class="texto_tam10">Site:</td>
              <td class="texto_tam10">
                <a :href="venda.id_con_id_site" target="_blank" class="texto_tam10" v-html="venda.id_con_id_site"></a>
              </td>
            </tr>
            <tr>
              <td class="texto_tam10">E-mail:</td>
              <td class="texto_tam10">
                <a :href="'mailto:' + venda.id_con_email" target="_blank" class="texto_tam10" v-html="venda.id_con_email"></a>
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>

      <div class="conteudo processo"  v-if="permissaoPCO === true">
        <!-- SETA O TITULO -->
        <div class="texto_tam12">
          Obs. Processo:
        </div>

        <!-- SETA O HISTORICO DO PROCESSO -->
        <Historico-do-processo :cpntRefMod="10" :cpntRefId="[ $route.params.vendaId ]"></Historico-do-processo>
      </div>

      <!-- SETA OS PRODUTOS FABRICADOS -->
      <div class="conteudo itens">
        <table>
          <thead>
            <tr>
              <td class="texto_tam14" style="text-align: center; letter-spacing: 6px;" :colspan="permissaoPCO === true ? 4 : 3">
                PRODUTOS
              </td>
            </tr>
            <tr>
              <td class="texto_tam12 codigo">
                Cód.
              </td>
              <td class="texto_tam12">
                Descrição
              </td>
              <td class="texto_tam12 qtde">
                Quantidade
              </td>
              <td class="texto_tam12 processo" v-if="permissaoPCO === true">
                Obs. Processo
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in itens" :key="'produto-' + item.id">
              <td class="texto_tam12 codigo">
                <span v-html="item.id_pro_codigo"></span>
              </td>
              <td class="texto_tam12 nome">
                <span v-html="item.id_pro_nome"></span>
              </td>
              <td class="texto_tam12 qtde">
                <span v-html="venReciboProducaoFormatarQtde(item.qtde)"></span>
                <span v-html="' ' + item.id_pro_id_uni"></span>
              </td>
              <td class="texto_tam12 processo" v-if="permissaoPCO === true">
                <Historico-do-processo :cpntRefMod="12" :cpntRefId="[ item.id ]"></Historico-do-processo>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- SETA OS PRODUTOS FABRICADOS -->
      <div class="conteudo itens">
        <table>
          <thead>
            <tr>
              <td class="texto_tam14" style="text-align: center; letter-spacing: 6px;" colspan="3">
                INSUMOS
              </td>
            </tr>
            <tr>
              <td class="texto_tam12 codigo">
                Cód.
              </td>
              <td class="texto_tam12 nome">
                Descrição
              </td>
              <td class="texto_tam12 qtde">
                Quantidade
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in insumos" :key="'insumo-' + item.id">
              <td class="texto_tam12 codigo">
                <span v-html="item.id_pro_consumido_codigo"></span>
              </td>
              <td class="texto_tam12">
                <span v-html="item.id_pro_consumido_nome"></span>
              </td>
              <td class="texto_tam12 qtde">
                <span v-html="venReciboProducaoFormatarQtde(item.qtde_sum)"></span>
                <span v-html="' ' + item.id_pro_consumido_id_uni"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="titulos">
        <span v-html="venReciboProducaoFormatarNumeroVenda(venda.cod_venda)"></span>
      </div>
      <div class="titulos">
        <span v-html="venReciboProducaoPegarPrimeiroNome(venda.id_con_nome)"></span>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .texto_tam10 {
    color: #000000;
    font-size: 10px;
    font-family: Verdana,Arial, Helvetica, sans-serif;
  }
  .texto_tam12 {
    color: #000000;
    font-size: 12px;
    font-family: Verdana,Arial, Helvetica, sans-serif;
  }
  .texto_tam14 {
    color: #000000;
    font-size: 14px;
    font-family: Verdana,Arial, Helvetica, sans-serif;
  }
  
  .ven-rec-producao {
    padding: 0px;
  }
  .ven-rec-producao > .conteudo {
    min-width: 699px;
    max-width: 800px;
    width: 800px;
    border: 1px solid #888888;
    margin: auto;
    padding: 5px;
  }
  .ven-rec-producao > .conteudo {
    border-top: none;
  }
  .ven-rec-producao > .conteudo:first-child {
    border-top: 1px solid #888888;
    margin-top: 5px;
  }
  .ven-rec-producao > .conteudo:last-child {
    margin-bottom: 5px;
  }
    .ven-rec-producao > .conteudo > table {
      width: 100%;
      border-spacing: 1px;
      border-collapse: separate;
    }
    .ven-rec-producao > .conteudo > table > tbody > tr > td {
      padding: 1px;
    }
    .ven-rec-producao > .conteudo > table > tbody > tr > td:first-child {
      width: 80px;
    }
  .ven-rec-producao > .itens > table {
    border-spacing: 0px;
    border-collapse: collapse;
  }
  .ven-rec-producao > .itens > table > thead > tr > td,
  .ven-rec-producao > .itens > table > tbody > tr > td {
    border: 1px solid #d5d5d5;
    padding: 4px;
  }
  .ven-rec-producao > .itens > table > thead > tr > td {
    font-weight: 600;
    background: #f6f6f6;
  }

  .ven-rec-producao > .itens > table > thead > tr > td.codigo,
  .ven-rec-producao > .itens > table > tbody > tr > td.codigo,
  .ven-rec-producao > .itens > table > thead > tr > td.qtde,
  .ven-rec-producao > .itens > table > tbody > tr > td.qtde {
    width: 120px;
  }
  .ven-rec-producao > .itens > table > thead > tr > td.codigo,
  .ven-rec-producao > .itens > table > tbody > tr > td.codigo {
    text-align: left;
  }
  .ven-rec-producao > .itens > table > thead > tr > td.nome,
  .ven-rec-producao > .itens > table > tbody > tr > td.nome {
    width: calc(100% - 240px);
  }
  .ven-rec-producao > .itens > table > thead > tr > td.qtde,
  .ven-rec-producao > .itens > table > tbody > tr > td.qtde {
    text-align: right;
  }
  .ven-rec-producao > .itens > table > thead > tr > td.processo,
  .ven-rec-producao > .itens > table > tbody > tr > td.processo {
    max-width: 200px;
  }
  .ven-rec-producao > .titulos {
    text-align: center;
    font-weight: bold;
    font-size: 35px;
    padding: 30px 0px;
    font-family: Verdana, Geneva, sans-serif;
  }
</style>

<style>
  #rf-web-body {
    padding: 0px !important;
  }
</style>

<script>
  export default {
    components: {
      'Historico-do-processo': () => import('@/components/controle-processo/painel/Historico-do-processo.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        licenca: {},
        venda: {},
        itens: [],
        insumos: [],
        vendaPCO: [],
        permissaoPCO: false
      }
    },
    mounted: function () {
      this.venReciboProducaoIniciar()
    },
    methods: {
      venReciboProducaoIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.venReciboProducaoSetarStatusGeral('carregando')

        // SETA SE TEM PERMISSÃO DE CONTROLE DE PROCESSOS
        this.permissaoPCO = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, [ 17 ], null, null, null, false) === true

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(null, {
          venReciboProducaoBuscarDadosVenda: [],
          venReciboProducaoBuscarItensVenda: [],
          venReciboProducaoBuscarInsumosVenda: [],
          venReciboProducaoFinalizar: [ 'venReciboProducaoBuscarDadosVenda', 'venReciboProducaoBuscarItensVenda', 'venReciboProducaoBuscarInsumosVenda', 'venReciboProducaoBuscarObsProcesso' ]
        }, {
          venReciboProducaoBuscarDadosVenda: (chave, callback) => { this.venReciboProducaoBuscarDadosVenda(() => { callback(chave) }) },
          venReciboProducaoBuscarItensVenda: (chave, callback) => { this.venReciboProducaoBuscarItensVenda(() => { callback(chave) }) },
          venReciboProducaoBuscarInsumosVenda: (chave, callback) => { this.venReciboProducaoBuscarInsumosVenda(() => { callback(chave) }) },
          venReciboProducaoFinalizar: (chave, callback) => { this.venReciboProducaoFinalizar(() => { callback(chave) }) }
        })
      },
      venReciboProducaoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venReciboProducaoFinalizar: function (callback = null) {
        // SETA O STATUS DA PAGINA
        this.venReciboProducaoSetarStatusGeral('')

        // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      venReciboProducaoBuscarDadosVenda: function (callback = null) {
        // INICIA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

        // SETA OS CAMPOS QUE DEVE RETORNAR
        queryGet.field = {
          cod_venda: null,
          vencimento: null,
          id_con: { j: {
            nome: null,
            empresa: null,
            cnpj_cpf: null,
            ie: null,
            tel_com: null,
            tel_cel: null,
            tel_res: null,
            email: null,
            site: null,
            end: null,
            num: null,
            comp: null,
            bairro: null,
            cep: null,
            id_cidade: { j: { cidade: null } },
            id_estado: null,
            pessoa: null
          } }
        }

        // VERIFICA SE DEVE BUSCAR OS ALIAS
        if ([ '', null, undefined ].indexOf(this.$store.state.licenca.j_alias) === -1) {
          queryGet.field.id_alias = null
        }

        // SETA O WHERE QUE SERÁ REALIZADO NA PAI
        queryGet.where = { aAnd: [ { f: 'cod_venda', o: '=', v: this.$route.params.vendaId } ] }

        // FAZ A BUSCA DOS DADOS NA API
        this.$store.state.comunicaAPI('/venda/get', 'POST', queryGet, (apiSuccess) => {
          // SETA OS DADOS RECEBIDOS
          this.venda = apiSuccess.data[0]

          // SETA OS DADOS DA LICENÇA DE USO
          this.licenca = this.$store.state.licenca

          // SETA A LOGO DA EMPRESA
          this.licenca.logotipo = this.$store.state.logotipo

          // VERIFICA SE TEM ALGUM ALIAS SELECIONADO
          if ([ '', null, undefined, '0' ].indexOf(this.venda.id_alias) === -1) {
            // PEGA A CHAVE QUE DEVE UTILIZAR
            var chave = Number(this.venda.id_alias - 1).toString()

            // SETA OS DADOS SOLICITADOS
            this.licenca = this.$store.state.licenca.j_alias[chave]

            // VERIFICA SE TEM O NOME DA EMPRESA PREENCHIDO
            if ([ '', null, undefined ].indexOf(this.licenca.rSocial) !== -1) {
              this.licenca.rSocial = this.licenca.nome
            }
  
            // INICIA O VETOR DA LOGOTIPO
            this.licenca.logotipo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/nao_encontrada.png'
  
            // VERIFICA SE TEM LOGOTIPO INSERIDA
            if ([ '', null, undefined ].indexOf(this.licenca.cod_img) === -1 && [ '', null, undefined, '0' ].indexOf(this.licenca.v_img) === -1) {
              this.licenca.logotipo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/' + this.licenca.cod_img + '.png?v=' + this.licenca.v_img
            }
          }

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, this.venReciboProducaoSetarStatusGeral)
      },
      venReciboProducaoBuscarItensVenda: function (callback = null, registros = [], total = null) {
        if (total === null || registros.length < total) {
          // INICIA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            id: null,
            data: null,
            cs: { j: { nome: null } },
            id_pro: { j: {
              codigo: null,
              nome: null,
              id_uni: null,
              id_cat: { j: { nome: null } }
            } },
            qtde: null
          }
  
          // SETA O WHERE QUE SERÁ REALIZADO NA PAI
          queryGet.where = { aAnd: [
            { f: 'status', o: '=', v: '1' },
            // { f: 'fabricado', o: '=', v: 's' },
            { f: 'cod_venda', o: '=', v: this.$route.params.vendaId }
          ] }

          // LIMPA A VARIAVEL DE ORDENAÇÃO
          queryGet.order = {}

          // ORDENANDO PELO CAMPO SELETOR
          // IMPLEMENTADO NO DIA 10/09/2021 11:49, POIS CONFORME INFORMADO PELO RAPHAEL, ESTAVA FALTANDO ESSA ORDENAÇÃO.
          if (this.$store.state.configuracoes.venda.doc.cfg_campo_sel === true) {
            queryGet.order = { cs_nome: 'asc' }
          }

          // SETA O TIPO DE ORDENAÇÃO
          // 25/09/2020 10:30 - Alterado para atender o cliente James CLU 1739
          // Corrigi provisoriamente a ordenação conforme solicitado pelo Raphael,
          // na tabela deveria ordenar pelo campo código, porem como ele é um char, acaba saindo uma ordenação errada do MYSQL. 
          // Este caso será analisando novamente no futuro provavelmente.

          // 09/09/2021 17:30 - Cliente James CLU 1739, solicitou que seja criado a opção ordenação por ordem alfabetica
          switch (this.$store.state.configuracoes.venda.ven.cfg_ordem) {
            case '0':
              queryGet.order = Object.assign(queryGet.order, { id_pro: 'asc', id: 'asc' })
              break

            case '1':
              queryGet.order = Object.assign(queryGet.order, { data: 'desc', id: 'asc' })
              break

            case '2':
              queryGet.order = Object.assign(queryGet.order, { id_pro_id_cat_nome: 'asc', id_pro_nome: 'asc', id: 'asc' })
              break

            case '3':
              queryGet.order = Object.assign(queryGet.order, { id_pro_nome: 'asc', id: 'asc' })
              break
          }

          // // SETA O AGRUPAMENTOS DOS REGISTROS
          // queryGet.group = [ 'id_pro' ]
  
          // FAZ A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI('/venda/produto/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.venReciboProducaoBuscarItensVenda(callback, registros, Number(apiSuccess.countAll))
          }, this.venReciboProducaoSetarStatusGeral)
        } else {
          // SETA OS REGISTROS RECEBIDOS
          this.itens = registros

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      },
      venReciboProducaoBuscarInsumosVenda: function (callback = null, registros = [], total = null) {
        if (total === null || registros.length < total) {
          // INICIA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            id: null,
            id_pro_consumido: { j: {
              codigo: null,
              nome: null,
              id_uni: null
            } },
            qtde: { o: 'sum' }
          }
  
          // SETA O WHERE QUE SERÁ REALIZADO NA PAI
          queryGet.where = { aAnd: [
            { f: 'status', o: '=', v: '1' },
            { f: 'cod_venda', o: '=', v: this.$route.params.vendaId }
          ] }

          // SETA O AGRUPAMENTOS DOS REGISTROS
          queryGet.group = [ 'id_pro_consumido' ]
  
          // FAZ A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI('/insumo/consumo/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.venReciboProducaoBuscarInsumosVenda(callback, registros, Number(apiSuccess.countAll))
          }, this.venReciboProducaoSetarStatusGeral)
        } else {
          // SETA OS REGISTROS RECEBIDOS
          this.insumos = registros

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      },
      venReciboProducaoFormatarVencimento: function (valor) {
        // IMPORTA BIBLIOTECA DEPENDENTE
        var moment = require('moment')

        // PEGA A DATA ATUAL
        var data = moment(valor, 'DD/MM/YYYY')

        // SETA O DIA DA DATA
        valor = data.format('DD') + ' de '

        // SETA O MÊS DA DATA
        switch (data.format('MM').toString()) {
          case '1':
          case '01':
            valor += 'Janeiro'
            break

          case '2':
          case '02':
            valor += 'Fevereiro'
            break

          case '3':
          case '03':
            valor += 'Março'
            break

          case '4':
          case '04':
            valor += 'Abril'
            break

          case '5':
          case '05':
            valor += 'Maio'
            break

          case '6':
          case '06':
            valor += 'Junho'
            break

          case '7':
          case '07':
            valor += 'Julho'
            break

          case '8':
          case '08':
            valor += 'Agosto'
            break

          case '9':
          case '09':
            valor += 'Setembro'
            break

          case '10':
            valor += 'Outubro'
            break

          case '11':
            valor += 'Novembro'
            break

          case '12':
            valor += 'Dezembro'
            break
        }

        // SETA O ANO DA DATA
        valor += ' de ' + data.format('YYYY')

        // RETORNA O VALOR MONTADO
        return valor
      },
      venReciboProducaoFormatarQtde: function (valor) {
        return this.$store.state.FUN_MASK_VALOR('valorDecimal2', valor.toString())
      },
      venReciboProducaoPegarPrimeiroNome: function (valor) {
        return valor.split(' ')[0]
      },
      venReciboProducaoFormatarNumeroVenda: function (valor) {
        return (valor.length <= 4 ? ('0000' + valor).slice(-4) : valor)
      },
      venReciboProducaoFormatarCep: function (valor) {
        // SETA A FORMATAÇÃO DO CEP
        var regex = /^([\d]{2})([\d]{3})([\d]{3})|^[\d]{2}.[\d]{3}-[\d]{3}/

        // VERIFICA SE SERÁ POSSIVEL FORMATAR O VALOR RECEBIDO
        return regex.test(valor) ? valor.replace(regex, '$1.$2-$3') : ''
      },
      venReciboProducaoCalcularTamanhoLogo: function () {
      if ([ '', null, undefined ].indexOf(this.$refs.logo) === -1) {
        // CARREGA OS VALORES
        var x = 165
        var y = 72
        
        // PEGA O TAMANHO DAS IMAGENS
        var imageWidth = this.$refs.logo.width
        var imageHeight = this.$refs.logo.height
        
        // CALCULA OS TAMANHOS PROPORCIONAIS
        if (imageHeight > y) {
          imageWidth = imageWidth * (y / imageHeight)
          imageHeight = y
  
          if (imageWidth > x) {
            imageHeight = imageHeight * (x / imageWidth)
            imageWidth = x
          }
        } else if (imageWidth > x) {
          imageHeight = imageHeight * (x / imageWidth)
          imageWidth = x
  
          if (imageHeight > y) {
            imageWidth = imageWidth * (y / imageHeight)
            imageHeight = y
          }
        }
        
        // SETA OS TAMANHOS CALCULADOS
        this.$refs.logo.style.width = imageWidth
        this.$refs.logo.style.height = imageHeight
      }
    }
  }
}
</script>
